const state = reactive({
  get_all: [],
  loading: false,
  page: 1,
  perPage: 12,
  total: null,
})

export function useLearnMoreArticles() {
  const storyblokApi = useStoryblokApi()
  const { locale } = useI18n()

  async function fetchAll(event) {
    state.loading = true
    try {
      const params = {
        version: 'published',
        per_page: state.perPage,
        page: state.page,
        language: locale.value,
        starts_with: 'learn-more/',
        is_startpage: false,
        excluding_slugs: 'learn-more/index',
        sort_by: 'created_at:desc',
      }

      const { data } = await storyblokApi.get('cdn/stories', params)

      if (data)
        state.get_all = data.stories
    }
    catch (error) {
      return sendError(event, createError({
        statusCode: 404,
        statusMessage: 'Unauthorized client error',
      }))
    }
    finally {
      state.loading = false
    }
  }

  return {
    ...toRefs(state),
    fetchAll,
  }
}
